import {Table, TBody, Td, Th, Thead, Tr} from '@/components';
import type {AfriexAdminTransaction} from '@/types/AfriexAdminTransaction';
import {capitalizeWords} from '@/utils/dashboard';
import * as formaTdate from '@/utils/date';

import formatStatementValues from './formatStatementValues';

const StatementTable = ({
  transactions,
}: {
  transactions: AfriexAdminTransaction[];
}) => {
  return (
    <Table>
      <Thead>
        <Tr enableHover={false}>
          <Th className="capitalize ps-5">Date</Th>
          <Th className="capitalize">Description</Th>
          <Th className="capitalize">Status</Th>
          <Th className="capitalize">Credit</Th>
          <Th className="capitalize">Debit</Th>
          <Th className="capitalize">Balance</Th>
        </Tr>
      </Thead>

      <TBody>
        {transactions.map((item, idx) => {
          return <TRow transaction={item} key={idx} />;
        })}
      </TBody>
    </Table>
  );
};

export default StatementTable;

const TRow = ({transaction}: {transaction: AfriexAdminTransaction}) => {
  const {description, credit, debit, balance} =
    formatStatementValues(transaction);
  return (
    <>
      <Tr>
        <Td className={`pl-4 py-4`}>
          {formaTdate.DDMonYYYY(transaction.createdAt?.toString() || '')}
        </Td>
        <Td className={`py-4`}>
          {/* `description` is genuinely optional now that its type isn't
          `any` (see formatStatementValues); `capitalizeWords('')` and the
          previous implicit `capitalizeWords(undefined)` both render nothing,
          so this keeps the same blank cell. */}
          {capitalizeWords(description?.replace(/_/g, ' ') ?? '')}
        </Td>
        <Td className={`py-4`}>
          {capitalizeWords(transaction.status?.replace(/_/g, ' ') ?? '')}
        </Td>
        <Td className={`py-4`}>{credit}</Td>
        <Td className={`py-4`}>{debit}</Td>
        <Td className={`py-4`}>{balance}</Td>
      </Tr>
    </>
  );
};
